import React from 'react';

const SocialLinks = () => {
  return (
    <>
      <div className="linkedin">
        <a href="https://www.linkedin.com/company/newowner-me/">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16">
            <path d="M13.938.188H1.184C.6.188.125.667.125 1.26v12.73c0 .591.475 1.072 1.06 1.072h12.753A1.07 1.07 0 0 0 15 13.99V1.26A1.07 1.07 0 0 0 13.938.187ZM4.62 12.938H2.416v-7.1h2.208v7.1h-.003Zm-1.102-8.07a1.279 1.279 0 1 1 .001-2.558 1.279 1.279 0 0 1 0 2.558Zm9.367 8.069H10.68V9.483c0-.823-.016-1.882-1.145-1.882-1.15 0-1.325.896-1.325 1.823v3.512H6.005V5.84H8.12v.97h.03c.296-.559 1.016-1.146 2.089-1.146 2.23 0 2.646 1.47 2.646 3.383v3.892Z" />
          </svg>
        </a>
      </div>
      <div className="xicon">
        <a href="https://www.youtube.com/@newownerme">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#fff"
            stroke="#fff"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-youtube"
          >
            <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
            <path d="m10 15 5-3-5-3z" />
          </svg>
        </a>
      </div>
      <div className="facebook">
        <a href="https://www.facebook.com/newowner.me">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18">
            <path d="m8.643 9.688.472-3.077H6.163V4.614c0-.841.413-1.662 1.735-1.662H9.24V.332S8.022.126 6.858.126c-2.431 0-4.02 1.474-4.02 4.141v2.345H.134v3.077h2.702v7.437h3.326V9.687h2.48Z" />
          </svg>
        </a>
      </div>
      <div className="instagram">
        <a href="https://www.instagram.com/newowner.me/">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16">
            <path d="M7.566 3.807A3.809 3.809 0 0 0 3.75 7.622a3.809 3.809 0 0 0 3.815 3.815 3.809 3.809 0 0 0 3.815-3.815 3.809 3.809 0 0 0-3.815-3.815Zm0 6.295a2.485 2.485 0 0 1-2.48-2.48 2.483 2.483 0 0 1 2.48-2.48 2.483 2.483 0 0 1 2.48 2.48 2.485 2.485 0 0 1-2.48 2.48Zm4.86-6.451a.89.89 0 1 0-1.779 0 .89.89 0 0 0 1.78 0Zm2.528.903c-.057-1.192-.33-2.248-1.202-3.118-.87-.87-1.926-1.142-3.118-1.202-1.229-.07-4.911-.07-6.14 0C3.307.29 2.25.563 1.378 1.433.504 2.303.235 3.358.175 4.55c-.07 1.229-.07 4.911 0 6.14.056 1.192.329 2.247 1.202 3.117.873.87 1.926 1.143 3.118 1.202 1.228.07 4.91.07 6.139 0 1.192-.056 2.248-.328 3.118-1.202.87-.87 1.142-1.925 1.202-3.117.07-1.229.07-4.908 0-6.136Zm-1.588 7.454a2.511 2.511 0 0 1-1.414 1.414c-.98.389-3.304.3-4.386.3-1.083 0-3.41.085-4.386-.3a2.511 2.511 0 0 1-1.415-1.414c-.388-.98-.299-3.304-.299-4.386 0-1.083-.086-3.41.3-4.386A2.507 2.507 0 0 1 3.18 1.821c.98-.388 3.303-.299 4.386-.299 1.082 0 3.41-.086 4.386.3.65.258 1.152.76 1.414 1.414.389.979.3 3.303.3 4.386 0 1.082.089 3.41-.3 4.386Z" />
          </svg>
        </a>
      </div>
    </>
  );
};

export default SocialLinks;
